// extracted by mini-css-extract-plugin
module.exports = {"srOnly":"styles_srOnly__tmF37"};